<template>
  <div class="page-content-wrapper">
    <div class="content sm-gutter">
      <div class="container-fluid container-fixed-lg padding-10">
        <alert-dynamic-component v-if="is_hubungkan_akun && notif && notif.status == 1 && !is_closed"
          :type="notif.type == 'info' ? 'warning' : 'danger'" :title="notif.type == 'info'
            ? `<i class='bi bi-info-circle'></i> ${notif.title}`
            : `<i class='bi bi-exclamation-circle'></i> ${notif.title}`
            " :subtitle="`${notif.content} <a href='${notif.link}' class='learn-more-notif' >${notif.name_link}</a>`"
          :closeNotif="closeNotif" class="m-b-10" />
        <alert-dynamic-component v-if="!facebook_token_valid && !is_notif_fb_closed" :type="'warning'"
          :title="`<i class='bi bi-info-circle'></i> Pemberitahuan!`"
          :subtitle="`Token akun facebook tidak valid. Silahkan hubungkan ulang akun facebook Anda. <a href='/settings' class='learn-more-notif' >Hubungkan Akun</a>`"
          :closeNotif="closeNotifFacebook" class="m-b-10" />
        <router-view />
      </div>
    </div>
    <div class="container-fluid container-fixed-lg footer">
      <div class="copyright sm-text-center">
        <!-- <p class="small-text no-margin pull-left sm-pull-reset">
          Sibernetik © {{ tahun_ini }} All Rights Reserved.
        </p> -->
        <p class="small no-margin pull-right sm-pull-reset">
          Sibernetik
          <span class="hint-text"> v{{ version }} </span>
        </p>
        <div class="clearfix" />
      </div>
    </div>
  </div>
</template>

<script>
import alert_dynamic from "@/views/components/alert_dynamic.vue";
import cookie from "js-cookie";

export default {
  name: "MainContent",
  components: {
    "alert-dynamic-component": alert_dynamic,
  },
  data() {
    return {
      version: process.env.PACKAGE_VERSION,
      tahun_ini: new Date().getFullYear(),
      notif: null,
      id_project: this.$store.getters.user.id_project,
      facebook_token_valid: true,
      token_fb: null,
    };
  },
  methods: {
    getNotif() {
      let api = process.env.VUE_APP_API_URL + "alert-message";
      this.$http
        .get(api)
        .then((res) => {
          this.notif = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCredentials() {
      let url =
        process.env.VUE_APP_API_URL +
        "get-user-creds-medsos/" +
        this.id_project;
      this.$http.get(url).then((res) => {
        if (res.status == 200) {
          this.token_fb = res.data.user_creds.creds.accessToken;
          if (
            "is_valid" in res.data.user_creds &&
            res.data.user_creds.is_valid == false
          ) {
            this.facebook_token_valid = false;
          } else {
            this.facebook_token_valid = true;
          }
        }
      });
    },
    closeNotif() {
      cookie.set("notif-code", this.notif.code);
    },
    closeNotifFacebook() {
      this.facebook_token_valid = true;
      cookie.set("notif-token-fb", this.token_fb);
    },
    is_hubungkan_akun: function () {
      if (this.$store.getters.isLoggedIn) {
        if (
          (!(
            "facebook" in
            this.$store.getters.user.project.project_detail.socmed_creds
          ) ||
            !(
              "twitter" in
              this.$store.getters.user.project.project_detail.socmed_creds
            )) &&
          this.$store.getters.user.project.project_detail.tipe == 1
        ) {
          return true;
        }
      }
      return false;
    },
  },
  computed: {
    is_closed: function () {
      let code = cookie.get("notif-code");
      if (code == this.notif.code) {
        return true;
      }
      return false;
    },
    is_notif_fb_closed: function () {
      let code = cookie.get("notif-token-fb");
      if (code == this.token_fb) {
        return true;
      }
      return false;
    },
  },
  mounted: function () {
    let self = this;
    self.getNotif();
    self.getCredentials();
  },
};
</script>
